import api from '../api'

const baseUrl = '/academy/api/AdminCourse'

const skillUpCourseProvider = {
  getCourse(id) {
    return api.get(`${baseUrl}/Get/${id}`)
  },
  setOrder(params) {
    return api.post(`${baseUrl}/EditCourseOrder`, params)
  },

  getAllCourseUsers(params = {}) {
    return api.post(`${baseUrl}/PeopleTable`, {
      params,
    })
  },

  getInputs() {
    return api.get(`${baseUrl}/Input`)
  },

  addCourse(params) {
    return api.post(`${baseUrl}/Add`, params)
  },

  getAvailableStatus(params) {
    return api.post(`${baseUrl}/AvailableStatus`, params)
  },

  updateAvailableStatus(params) {
    return api.put(`${baseUrl}/EditStatus`, params)
  },

  updateCourse(params = {}) {
    return api.put(`${baseUrl}/Edit`, params)
  },

  deleteCourse(params) {
    return api.delete(`${baseUrl}/Delete/${params}`)
  },

  addCoursePrerequisite(params) {
    return api.post(`${baseUrl}/Prerequisite`, params)
  },

  searchCoursePrerequisite(params) {
    return api.post(`${baseUrl}/SearchPrerequisite`, params)
  },

  deleteCoursePrerequisite(params = {}) {
    return api.delete(`${baseUrl}/Prerequisite`, { params })
  },

  updateCourseUserRole(params = {}) {
    return api.put(`${baseUrl}/ProductPeopleRole`, params)
  },

  getAdminClassList(params) {
    return api.get(`${baseUrl}/AdminProductPeople/id?id=${params}`)
  },

  generateLoginUrl(params = {}) {
    return api.post(`/BizSchool/api/Home/LoginUrl`, params)
  },

  getTrainUsers(params) {
    return api.get(`${baseUrl}/PracticePeopleTable/id?id=${params}`)
  },

  updateUserTrainScore(params = {}) {
    return api.put(`${baseUrl}/PracticePeopleScore/id`, params)
  },

  setUserScore(params) {
    return api.post(`${baseUrl}/EditScore`, params)
  },
  userLicenseRequest(params) {
    return api.post(`${baseUrl}/LicenseRequest`, params)
  },
  getPractice(id) {
    return api.get(`${baseUrl}/GetPractice/id?id=${id}`)
  },
  editPracticeStatus(params) {
    return api.put(`${baseUrl}/EditPracticeStatus`, params)
  },
  getCourseUsers(id) {
    return api.get(`${baseUrl}/GetCoursePeople/${id}`)
  },
}

export default skillUpCourseProvider
